import { render } from "./quanyuroi3.vue?vue&type=template&id=61e9d6c6&scoped=true"
import script from "./quanyuroi3.vue?vue&type=script&lang=js"
export * from "./quanyuroi3.vue?vue&type=script&lang=js"

import "./quanyuroi3.vue?vue&type=style&index=0&id=61e9d6c6&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e9d6c6"]])

export default __exports__